import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconShareStyle0 = cosmosIconCss;

const CosmosIconShare$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconShare extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4188995dbe9eff24241c16d102fac799d707e597', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '98748cd444a6a4dc510ae337cd111e6b1db421a5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '642d11d93c3893e23276591c66840418d18a2249', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 13.5a2.5 2.5 0 0 0-1.93.93l-5.61-3a3.13 3.13 0 0 0 0-.44c.01-.15.01-.3 0-.45l5.62-3A2.49 2.49 0 1 0 13.5 6a1.116 1.116 0 0 0 0 .19l-5.76 3a2.5 2.5 0 1 0 0 3.54l5.76 3.06a1.005 1.005 0 0 0 0 .17A2.5 2.5 0 1 0 16 13.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconShareStyle0; }
}, [1, "cosmos-icon-share", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-share"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-share":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconShare$1);
            }
            break;
    } });
}

const CosmosIconShare = CosmosIconShare$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconShare, defineCustomElement };
